export enum TipoComision {
  DICTAMINADORA = 'DICTAMINADORA',
  RECONSIDERACION = 'RECONSIDERACION',
  REVISORA = 'REVISORA',
}
